import { DatePickerDesignTokens } from '@primeuix/themes/types/datepicker';

import {
  getColor,
  getFontWeight,
  getRem,
} from '@customer-portal/shared/helpers/theme-utils';

export const datePickerOverride: DatePickerDesignTokens = {
  title: {
    fontWeight: getFontWeight('bold'),
  },

  selectMonth: {
    color: getColor('DarkBlue'),
    hoverColor: getColor('SkyBlue55'),
    hoverBackground: 'transparent',
    padding: getRem(6),
  },

  selectYear: {
    color: getColor('DarkBlue'),
    hoverColor: getColor('SkyBlue55'),
    hoverBackground: 'transparent',
    padding: getRem(6),
  },

  header: {
    padding: getRem(6),
  },

  panel: {
    color: getColor('SeaBlue'),
    borderRadius: getRem(10),
    padding: getRem(6),
    shadow: `0 ${getRem(3)} ${getRem(6)}
       ${getColor('DarkBlack')}`,
  },

  monthView: {
    margin: `${getRem(6)} 0`,
  },
  yearView: {
    margin: `${getRem(6)} 0`,
  },

  dayView: {
    margin: `${getRem(6)} 0`,
  },

  month: {
    padding: getRem(6),
  },
  year: {
    padding: getRem(6),
  },

  weekDay: {
    fontWeight: getFontWeight('bold'),
    color: getColor('DarkBlue'),
    padding: getRem(6),
  },

  date: {
    color: getColor('DarkBlue'),
    rangeSelectedBackground: '{primary.color}',
    rangeSelectedColor: '{primary.contrast.color}',
    hoverBackground: getColor('UiLightGray'),
    width: getRem(30),
    height: getRem(30),
    padding: getRem(6),
  },

  inputIcon: {
    color: getColor('DarkBlue'),
  },

  colorScheme: {
    light: {
      today: {
        color: getColor('DarkBlue'),
        background: getColor('LightGray'),
      },
    },
  },
};
